import { render, staticRenderFns } from "./addEmail.vue?vue&type=template&id=6ca21f8e&scoped=true&"
import script from "./addEmail.vue?vue&type=script&lang=js&"
export * from "./addEmail.vue?vue&type=script&lang=js&"
import style0 from "./addEmail.vue?vue&type=style&index=0&id=6ca21f8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca21f8e",
  null
  
)

export default component.exports